import { PressList as HygraphPressListProps } from '@/lib/types';

import { PressList, PressListProps } from '@/features/press';

export default function PressListRenderer(props: HygraphPressListProps) {
  const data = props as HygraphPressListProps;

  const componentProps: PressListProps = {
    id: data.id,
    featured: data.featured || undefined,
    useLogo: data.useLogo || undefined,
    limit: data.limit || undefined,
    title: data.title || undefined,
  };

  return <PressList {...componentProps} />;
}
